module.exports = __webpack_public_path__ + "img/mini-014.a747e13c.jpg";